<script lang="ts">
	import Step from "../components/wizard/Step.svelte";
	import NextButton from "../components/NextButton.svelte";
	import TwoCols from "../components/TwoCols.svelte";
	import Radio from "../components/Radio.svelte";
	import {asdf, qwertz} from "../keybindings";
	import {Utils} from "../util";
	import {translations} from "../translations";
	import ErrorBox from "../components/ErrorBox.svelte";
	import { _ } from '../services/i18n.js';


	export let currentStep: number;

	export let source: string;
	export let otherSource: string;
	declare var lang: string;
	let otherInput: HTMLInputElement;

	const options = [
		{key: qwertz[0], translation: translations.sources.website, value: "website"},
		{key: qwertz[1], translation: translations.sources.newsgroup, value: "newsgroup"},
		{key: qwertz[2], translation: translations.sources.socialnetwork, value: "social-network"},
		{key: qwertz[3], translation: translations.sources.tor, value: "tor"},
		{key: asdf[0], translation: translations.sources.app, value: "app"},
		{key: asdf[1], translation: translations.sources.filehoster, value: "file-hoster"},
		{key: asdf[2], translation: translations.sources.streaming, value: "streaming"},
		{key: asdf[3], translation: translations.sources.ftp, value: "ftp"},
		{key: asdf[4], translation: translations.sources.other, value: "other"},
	];

	$: {
		if (source === "other") {
			setTimeout(() => { // wait for otherInput to show up
				otherInput?.focus();
			}, 0);

		}

		if(currentStep == 2){

			console.log("set focus for 2")
		}
	}



	export function validate() {
		showErrors = true;
		return !!source && (source !== "other" || !!otherSource);
	}

	let showErrors = false;

	function init(el){
		console.log("init 2");
		//el.focus()
	}
	// use:init


</script>

<Step let:nextStep num={2} {validate}>
	<TwoCols rightStyle="display: flex; flex-direction: column" ratio={0.6}>
		<svelte:fragment slot="left">
			<h1 class="main-heading">{$_('stepSource.title')}</h1>
			<ul class="source-container">
			{#each options as option}
				<li class="radio-container">
					<Radio bind:group={source} value={option.value}>
						{Utils.chooseTranslation(option.translation)}
					</Radio>
				</li>
			{/each}
			</ul>
			{#if source === "other"}
				<input bind:this={otherInput} type="text" title="Add other information" placeholder="Add other information" bind:value={otherSource} on:keypress|stopPropagation|capture>
				<ErrorBox show={showErrors && !otherSource} msg="Please enter a source"></ErrorBox>
			{/if}
			<ErrorBox show={showErrors && !source} msg="Please choose a source"></ErrorBox>
		</svelte:fragment>
		<svelte:fragment slot="right">

			{#if lang == 'en'}
			<h2 class="red-title">Platforms</h2>

			<p class="info-text">
				Please select the location where you encountered the illegal content.
			</p>
			<p class="info-text">
				For cases where the illegal content was received by e-mail,
				we are unable to ask you for details like e-mail address of sender or content of e-mail content
				according to the law of 11th of August 1982 on the protection of private life and
				secrecy of correspondence.
				However, we advise you to inform the Police Grand-Ducal directly,
				the only body able to bypass the secrecy of correspondence in the case of illegal content
				received by e-mail.
			</p>
			{/if}
			{#if lang == 'de'}
			<h2 class="red-title">Plattformen</h2>

			<p class="info-text">
				Wählen Sie bitte, wo Sie auf den illegalen Inhalt gestoßen sind.
			</p>
			<p class="info-text">
				Im Fall, dass Sie den illegalen Inhalt per E-mail erhalten haben,
				können wir keine Details erheben. Die E-mail Adresse des Absenders und der Inhalt
				der E-mail unterliegen aufgrund des Gesetzes vom 11, August 1982 dem Schutz der Privatsphäre und
				dem Briefgeheimnisses.
				Wir raten Ihnen jedoch sich an die Polizei zu wenden, da diese im Fall von einem illegalen Inhalt dazu befugt ist, das Briefgeheimnis zu brechen.
			</p>
				{/if}
				{#if lang == 'fr'}
					<h2 class="red-title">Plateformes</h2>

					<p class="info-text">
						Veuillez sélectionner l'endroit où vous avez rencontré le contenu illégal.
					</p>
					<p class="info-text">
						Dans le cas où le contenu illégal aurit été reçu par e-mail, il nous est impossible de vous demander
						les détails comme l'adresse e-mail de l'expéditeur ou le contenu de l'email, compte tenu
						de la loi du 11 août 1982 relative à la protection de la vie privée et au secret des correspondances.
						Nous vous suggérons néanmoins d'en informer directement la Police grand-ducale, seule organisme habilité
						à rompre le secret des correspondances lorsqu'un cas de contenu illégal par e-mail serait avéré.
					</p>
					{/if}


					<NextButton {nextStep}></NextButton>
		</svelte:fragment>
	</TwoCols>

</Step>

<style lang="scss">
	.main-heading {
      margin-bottom: 25px;
    }

    .radio-container {
      margin-bottom: 10px;

    }


    .heading-subtitle {
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0;
      text-align: left;
    }

    input {
      background: white;
      border: 2px dashed black;

      margin-bottom: 2px;
    }

	.source-container{
		padding: 0;
		list-style-type: none;
	}
	.source-container li{
		list-style-type:none;
	}
</style>
